import { IconProps } from 'types/icon.type'

export const MaestroIcon = (props: IconProps) => {
  return (
    <svg
      width="55"
      height="32"
      viewBox="0 0 55 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Maestro Logo</title>
      <rect x="0.5" width="54" height="32" rx="6" fill="white" />
      <path
        d="M30.6967 16C30.6967 21.0205 26.6233 25.0904 21.5984 25.0904C16.5735 25.0904 12.5 21.0205 12.5 16C12.5 10.9795 16.5735 6.90965 21.5984 6.90965C26.6233 6.90965 30.6967 10.9795 30.6967 16Z"
        fill="#ED0006"
      />
      <path
        d="M42.5 16C42.5 21.0205 38.4265 25.0904 33.4016 25.0904C28.3767 25.0904 24.3032 21.0205 24.3032 16C24.3032 10.9795 28.3767 6.90965 33.4016 6.90965C38.4265 6.90965 42.5 10.9795 42.5 16Z"
        fill="#0099DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4999 22.9188C29.4562 21.2515 30.6966 18.7705 30.6966 16C30.6966 13.2296 29.4562 10.7486 27.4999 9.08125C25.5437 10.7486 24.3032 13.2296 24.3032 16C24.3032 18.7705 25.5437 21.2515 27.4999 22.9188Z"
        fill="#6C6BBD"
      />
    </svg>
  )
}
